export const START_FETCH_AGENTS = 'START_FETCH_AGENTS';

export const SET_FETCHED_AGENTS = 'SET_FETCHED_AGENTS';

export const SET_FETCHED_AGENT_COUNT = 'SET_FETCHED_AGENT_COUNT';

export const FETCH_AGENTS_ERROR = 'FETCH_AGENTS_ERROR';

export const START_FETCH_MORE_AGENTS = 'START_FETCH_MORE_AGENTS';

export const APPEND_FETCHED_AGENTS = 'APPEND_FETCHED_AGENTS';

export const FETCH_ENDED = 'FETCH_ENDED';

export const FETCHED_AGENT = 'FETCHED_AGENT';

export const SET_FILTER = 'SET_FILTER';

export const UNSET_FILTER = 'UNSET_FILTER';

export const SET_ICS_TYPE = 'SET_ICS_TYPE';

export const SET_PAGE = 'SET_PAGE';
